<script setup lang="ts">
import { Separator } from "~/components/ui/separator"
import { useBrandedPageMeta } from "~/composables/brandedPageMeta"
import { generateAccessibilityStatement } from "./utils/accessibility"

useBrandedPageMeta("Accessibility Statement")

const accessibilityStatementHTML = generateAccessibilityStatement()
</script>

<template>
    <section class="w-full flex flex-col gap-10 md:gap-12 max-w-5xl mx-auto px-4 md:px-6 py-32">
        <header class="space-y-4 text-center">
            <h1 class="text-3xl md:text-4xl font-headline">
                Accessibility Statement
            </h1>
            <Separator class="w-10 mx-auto bg-foreground" />
            <p>
                Last updated: February 3, 2025
            </p>
        </header>
        <div
            class="flex flex-col gap-3 md:gap-4 prose prose-sm max-w-none"
            v-html="accessibilityStatementHTML"
        />
    </section>
</template>
